import { render, staticRenderFns } from "./AccordList.vue?vue&type=template&id=4ecfa994&scoped=true&"
import script from "./AccordList.vue?vue&type=script&lang=js&"
export * from "./AccordList.vue?vue&type=script&lang=js&"
import style0 from "./AccordList.vue?vue&type=style&index=0&id=4ecfa994&scoped=true&lang=less&"
import style1 from "./AccordList.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecfa994",
  null
  
)

export default component.exports